import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../store/store"; // Assuming your store file is named 'store.ts'
import { Button, Card, Divider, Form, Input } from "antd";

import { LockOutlined, UserOutlined } from "@ant-design/icons";

import { getProfile, signUp } from "../store/actions/user";
import { useState } from "react";
import { DollarSign } from "lucide-react";

interface OwnProps {}

type CorePageProps = OwnProps & PropsFromRedux;

const CorePage: React.FC<CorePageProps> = ({ isLoggedIn, login, signin }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleLogin = async (values: any) => {
    setLoading(true);
    await login(values);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex items-center justify-center p-4">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>

      {/* Login Card */}
      <Card className="w-full max-w-md app-surface backdrop-blur-xl shadow-2xl border-0 rounded-2xl">
        <div className="text-center mb-8">
          {/* Logo */}
          <div className="flex items-center justify-center mb-4">
            <div className="bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-2xl p-3 shadow-lg">
              <DollarSign className="h-8 w-8 text-white" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold bg-gradient-to-r from-emerald-600 to-blue-600 bg-clip-text text-transparent mb-2">
            Digital Lottery System
          </h1>
          <p className="app-muted">
            Sign in to your Lottery dashboard
          </p>
        </div>

        {/* Login Form */}
        <Form
          // form={form}
          name="login"
          onFinish={handleLogin}
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: "Please enter your email!" },
              { type: "email", message: "Please enter a valid email!" },
            ]}
          >
            <Input
              prefix={<UserOutlined className="app-muted" />}
              placeholder="Email address"
              className="rounded-lg"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please enter your password!" }]}
          >
            <Input.Password
              prefix={<LockOutlined className="app-muted" />}
              placeholder="Password"
              className="rounded-lg"
              // iconRender={(visible) =>
              //   visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              // }
            />
          </Form.Item>

          {/* <Form.Item>
            <div className="flex items-center justify-between">
              <Checkbox>Remember me</Checkbox>
              <Button
                type="link"
                className="p-0 text-emerald-600 hover:text-emerald-700"
              >
                Forgot password?
              </Button>
            </div>
          </Form.Item> */}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              className="h-12 rounded-lg bg-gradient-to-r from-emerald-500 to-emerald-600 border-0 hover:from-emerald-600 hover:to-emerald-700 shadow-lg"
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </Form.Item>
        </Form>

        <Divider className="app-border" />

        {/* Footer */}
        <div className="text-center text-xs app-muted">
          <p>© 2025 All rights reserved Bintree softwares.</p>
          <p className="mt-1">Secure lottery management system</p>
        </div>
      </Card>

      {/* Floating Elements */}
      <div className="absolute top-10 left-10 w-20 h-20 bg-gradient-to-br from-emerald-400/20 to-blue-400/20 rounded-full blur-xl"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-gradient-to-br from-purple-400/20 to-pink-400/20 rounded-full blur-xl"></div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  isLoggedIn: state?.user?.isLoggedIn,
});

const mapDispatchToProps = (dispatch: any) => ({
  login: (data: any) => dispatch(getProfile(data)),
  signin: (data: any) => dispatch(signUp(data)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

// Define the props that connect will inject into the component
type PropsFromRedux = ConnectedProps<typeof connector>;

// Connect the component to Redux
export default connector(CorePage);
